import { Suspense, lazy } from 'react';
import { Box } from 'src/components/Box';
import { Loader } from 'src/components/Loader';

type RichTextEditorProps = {
  value: string;
  onChange: (value: string) => void;
  autofocus?: boolean;
  mentionSuggestions?: string[];
};

const SynchronousRichTextEditor = lazy(
  () => import('./RichTextEditor/SynchronousRichTextEditor')
);

const loadingState = (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: 600,
    }}
  >
    <Loader size="large" />
  </Box>
);

export const RichTextEditor = ({ ...props }: RichTextEditorProps) => {
  return (
    <Suspense fallback={loadingState}>
      <SynchronousRichTextEditor {...props}></SynchronousRichTextEditor>
    </Suspense>
  );
};
